const QUALTRICS_URL = new URL('https://pricelineresearch.qualtrics.com/jfe/form/SV_3jXKJkoqkydiAjI');
const COSTUMER_SUPPORT_NUMBER = '1-773-922-6363';
const SALES_NUMBER = '1-833-881-0904';
const ROLE_ASSISTANT = 'assistant';
export { COSTUMER_SUPPORT_NUMBER, QUALTRICS_URL, ROLE_ASSISTANT, SALES_NUMBER };
